import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { retry, catchError } from 'rxjs/operators';
import { GlobalService } from 'src/app/global.service';
import { HttpClient,HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http:HttpClient,private global:GlobalService) { 

  }
  public adminupload(filetype,filename,agentname,formData){
    console.log("Full URL: ",this.global.Baseurl+this.global.adminuploadWS)
    return this.http.post(this.global.Baseurl+this.global.adminuploadWS+"/"+filetype+"/"+filename+"/"+agentname,formData);
  } 

  public promotionupload(type,promotion,agentname,Form){
    
    console.log("Full URL: ",this.global.Baseurl+this.global.promotionuploadWS)
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl+this.global.promotionuploadWS+"/"+type+"/"+promotion+"/"+agentname,Form,{headers:headers});
  } 

  public fleetupload(formData){
    
    console.log("Full URL: ",this.global.Baseurl+this.global.getfleetupload,formData)
    return this.http.post(this.global.Baseurl+this.global.getfleetupload,formData);
    
    }
    public getFleetListing(userName){
      
    console.log("Full URL: ",this.global.Baseurl+this.global.getfleetlist+"/"+userName)
    return this.http.get(this.global.Baseurl+this.global.getfleetlist+"/"+userName);
    }

    public deletFile(sno,deleteflag){
      
      console.log("Full URL: ",this.global.Baseurl+this.global.deletFile+"?sno="+sno+"&&deleteflag="+deleteflag)
      return this.http.get(this.global.Baseurl+this.global.deletFile+"?sno="+sno+"&&deleteflag="+deleteflag);
   }

   public adminimgupload(formData){
     
    console.log("Full URL: ",this.global.Baseurl+this.global.adminimgupload,formData);
    return this.http.post(this.global.Baseurl+this.global.adminimgupload,formData);
  }
  
  public requestUpload(formData){
    
    console.log("Full URL: ",this.global.Baseurl+this.global.requestUpload,formData);
    return this.http.post(this.global.Baseurl+this.global.requestUpload,formData);    
  }
}
